import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "loading-overlay-loader" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["loading-overlay auth-loading-overlay", { hidden: !_ctx.display }])
  }, _hoisted_2, 2))
}